"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var isNull_1 = __importDefault(require("lodash/isNull"));
var SelectInput = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, options = _a.options;
    return (react_1.default.createElement("div", { className: "usersEstimatesRequestsMessages-UserProfileModal_InputWrapper" },
        react_1.default.createElement("label", { htmlFor: label, className: "usersEstimatesRequestsMessages-UserProfileModal_InputLabel" }, label),
        react_1.default.createElement("select", { id: label, value: (0, isNull_1.default)(value) ? undefined : value, onChange: function (e) { return onChange(e.target.value || null); }, className: "usersEstimatesRequestsMessages-UserProfileModal_Select" }, __spreadArray([undefined], options, true).map(function (option) { return (react_1.default.createElement("option", { key: option, value: option }, option || '選択してください')); }))));
};
exports.default = SelectInput;
